import styled from 'styled-components';

import { Text } from '@yoweb/ui/components/typography';
import { getSpace, getFontWeight } from '@yoweb/ui/styles/utils/theme';

const TextLegalese = styled(Text)`
  && {
    margin-top: ${getSpace('normal1')};
  }
`;

TextLegalese.defaultProps = {
  size: 'md',
};
TextLegalese.displayName = 'TextLegalese';

const Bold = styled.span`
  font-weight: ${getFontWeight('bold')};
`;

const Italic = styled.span`
  font-style: italic;
`;

export { TextLegalese, Bold, Italic };
